import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import useLocalStorageData from "../../schooladmin/Comman/LocalStorageData";
import Select from "react-select";
import { Heading } from "../../CommonComponent/heading";
import { MonthlyAttendenceAPI } from "../../../api/Payroll/MonthlyAttendence";
import { EssDasbaord } from "../../../api/Ess/Essleaves";
const EssLeaves = () => {
  const { school_id, token, school_emp_id } = useLocalStorageData();
  const [selectedEmpId, setSelectedEmpId] = useState("");
  const [isHalfDay, setIsHalfDay] = useState(false);
  const [Date1, setDate1] = useState(new Date().toISOString().slice(0, 7));
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [remLeave, setRemLeave] = useState(0);
  const [firstDay, setFirstDay] = useState("");
  const [lastDay, setLastDay] = useState("");
  const [leaveDays, setLeaveDays] = useState(0);
  const [leaveData, setLeaveData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [weekoff, setWeekoff] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [appliedLeaves, setAppliedLeaves] = useState([]);
  const [activeTab, setActiveTab] = useState("application");
  const user = JSON.parse(localStorage.getItem("school_user"));

  const { user_detail } = user || {};

  let handelLeaveChange = (select) => {
    setSelectedOption(select.value);
    const selectedLeaveType = select.label;
    const remainingLeave = select.bal;
    setRemLeave(remainingLeave || 0);
    formik.setFieldValue("leave_type_id", select.value);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
    formik.setFieldValue("from_date", event.target.value);
    if (isHalfDay) {
      formik.setFieldValue("to_date", event.target.value);
    }
  };
  function getCurrentMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // add leading zero
  return `${year}-${month}`;
}


  const getEmployList = async () => {
    try {
      let data = {
        school_id: user_detail.fk_school_id,
        attendance_month: getCurrentMonth(),
        staff_id: user_detail.staff_id,
      };

      // startLoading();
      const response = await MonthlyAttendenceAPI.GetAttendanceData(data);
      const responseData = response.data;
      if (responseData.status === 200) {
        // setEmployeeObject(responseData);
        // setEmployeeDetails(responseData?.result);
        console.log("i am inside");

        const options = responseData.leave_type_arr.map((item) => {
          const label = item.leave_type;
          const value = item.id;
          const bal = item.leave_balance;
          return { label: label, value: value, bal: bal };
        });
        setOptions(options);

        // setMonthDays(responseData?.total_days);
        // setIsGenerated(responseData?.is_salary_generated);
        setWeekoff(responseData?.weekoff_arr);

        setHoliday(responseData?.holiday_arr);

        let date = new Date(Date1);

        const year = date.getFullYear();
        const month = date.getMonth();

        const firstDay = new Date(year, month, 1).toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        // console.log(firstDay, "firstDay ::::::::::");
        const lastDay = new Date(year, month + 1, 0).toLocaleDateString(
          "en-CA",
          {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }
        );

        setFirstDay(firstDay);
        setLastDay(lastDay);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // stopLoading();
    }
  };

  useEffect(() => {
    // getLeaveData();
    getEmployList();
    getapplyedLeaveData();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      school_id: school_id,
      staff_id: user_detail?.staff_id,
      leave_type_id: "",
      from_date: "",
      to_date: "",
      attendance_month: Date1,
      is_approved: "Pending",
      number_of_leaves: "",
      reason: "",
    },
    validationSchema: Yup.object().shape({
      leave_type_id: Yup.string().required("Leave type is required"),
      from_date: Yup.string().required("From date is required"),
      to_date: isHalfDay
        ? Yup.string().nullable(true)
        : Yup.string().required("To date is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: async (values) => {
      let isFirst = "";
      if (isHalfDay) {
        isFirst = isLeft ? "First" : "Second";
        setLeaveDays(0.5);
      } else {
        isFirst = "";
      }

      values = {
        ...values,
        leave_balance: remLeave,
        half_1or2: isFirst,
        half_full_day: isHalfDay ? "Half" : "Full",
        number_of_leaves: leaveDays,
      };

      try {
        // startLoading();
        const response = await EssDasbaord.save_leave_application_temp(values);
        const responseData = response.data;
        if (responseData.status === 200) {
          // stopLoading();
          Swal.fire({
            text: responseData.msg,
            icon: "success",
          }).then(() => {
            handelClear();
            getEmployList();
            getapplyedLeaveData()
          });
        } else {
          Swal.fire({
            text: responseData.msg,
            icon: "error",
            allowOutsideClick: false,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        // stopLoading();
      }
    },
  });

  useEffect(() => {
    if (fromDate && toDate) {
      const excludeDays = weekoff.map((day) => dayNameToNumber[day]);

      const holidays = holiday;
      calculateLeaveDays(fromDate, toDate, excludeDays, holidays);
    }
  }, [fromDate, toDate, weekoff]);


  console.log(fromDate , toDate)

  const calculateLeaveDays = (
    fromDate,
    toDate,
    excludeDays = [],
    holidays = []
  ) => {
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
    const start = new Date(fromDate);

    const end = new Date(toDate);

    // Ensure end date is after start date
    if (end < start) {
      setLeaveDays(0);
      formik.setFieldValue("number_of_leaves", 0);
      return;
    }

    // Calculate the number of days between start and end
    const totalDays = Math.round(Math.abs((end - start) / oneDay)) + 1;

    // Convert holidays to Date objects for comparison
    const holidayDates = holidays.map((holiday) =>
      new Date(holiday).setHours(0, 0, 0, 0)
    );

    // Count the number of excluded days and holidays within the leave period
    let leaveDays = 0;
    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      const day = date.getDay();
      const currentDate = date.setHours(0, 0, 0, 0); // Set time to 00:00:00 for accurate comparison
      if (!excludeDays.includes(day) && !holidayDates.includes(currentDate)) {
        leaveDays++;
      }
    }

    setLeaveDays(leaveDays);
    formik.setFieldValue("number_of_leaves", leaveDays);
  };

  const dayNameToNumber = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const handelClear = () => {
    formik.resetForm();

    setSelectedOption("");
    setFromDate("");
    setToDate("");
    // setModal(!modal);
    // setApprove(false);
    setIsHalfDay(false);
    setRemLeave(0);
        setLeaveDays(0);
  };

  const handelHalfDay = () => {
    setIsHalfDay(!isHalfDay);
    setLeaveDays(0.5);
    formik.setFieldValue("to_date", fromDate);
  };

  const handleToDateChange = (e) => {
    const { value } = e.target;

    const fromDateValue = new Date(formik.values.from_date);
    const toDateValue = new Date(value);

    // Check if the selected "To Date" is before the "From Date"
    if (toDateValue < fromDateValue) {
      formik.setFieldError("to_date", "To Date must be after From Date");
    } else {
      // Clear the error if the validation passes
      formik.setFieldError("to_date", "");
      formik.setFieldValue("to_date", value);
      setToDate(value);
    }
  };

  const [isLeft, setIsLeft] = useState(true);

  const handleLeftClick = () => {
    setIsLeft(true);
  };

  const handleRightClick = () => {
    setIsLeft(false);
  };

  const getapplyedLeaveData = async () => {
    let data = {
      school_id: user_detail.fk_school_id,
      staff_id: user_detail.staff_id,
    };
    try {
      const response = await EssDasbaord.getAppliedLeaves(data);
      setAppliedLeaves(response.data);
    } catch (error) {
      console.error("Error fetching applied leaves:", error);
    }
  };

  // console.log(appliedLeaves, "valuesvaluesvaluesvaluesvaluesvalues");

  // console.log(weekoff, "this are weekoffs");
  return (
    <div>
      <div>
        <div className="container ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0 fw-bold">Leave Management</h4>
            <ul className="nav nav-tabs custom-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "application" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("application")}
                >
                  Apply for Leave
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "previous" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("previous")}
                >
                  Previous Applications
                </button>
              </li>
            </ul>
          </div>
          <div className="card shadow">
            <div className="d-flex justify-content-between align-items-center mb-3"></div>
            {activeTab === "application" ? (
              <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">
                        Leave Type <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={options}
                        value={
                          selectedOption
                            ? options?.find((c) => c.value === selectedOption)
                            : null
                        }
                        onChange={handelLeaveChange}
                      />
                      {formik.touched.leave_type_id &&
                        formik.errors.leave_type_id && (
                          <div className="text-danger mt-1">
                            {formik.errors.leave_type_id}
                          </div>
                        )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Leave Balance</label>
                      <input
                        type="text"
                        className="form-control"
                        value={remLeave}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-lg-12  row form-group ">
                    <div className=" col-lg-12 ">
                      <label className="col-form-label ">Half Day</label>
                    </div>
                    <div className="col-lg-12">
                      <label className="custom-switch">
                        <input
                          type="checkbox"
                          className="custom-switch-input"
                          name="login_user"
                          checked={isHalfDay}
                          onChange={handelHalfDay}
                        />
                        <span className="custom-switch-indicator"></span>
                      </label>
                    </div>

                    {isHalfDay && (
                      <div className="col-lg-12">
                        <div className="form-box">
                          <div className="button-box">
                            <div
                              id="btn"
                              className={isLeft ? "" : "right"}
                            ></div>
                            <button
                              type="button"
                              className="toggle-btn"
                              onClick={handleLeftClick}
                            >
                              First Half
                            </button>
                            <button
                              type="button"
                              className="toggle-btn"
                              onClick={handleRightClick}
                            >
                              Second Half
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">
                        From Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="from_date"
                        // min={firstDay}
                        // max={lastDay}
                        value={formik.values.from_date}
                        onChange={handleFromDateChange}
                      />
                      {formik.touched.from_date && formik.errors.from_date && (
                        <div className="text-danger mt-1">
                          {formik.errors.from_date}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        To Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="to_date"
                        // min={firstDay}
                        // max={lastDay}
                        value={formik.values.to_date}
                        onChange={handleToDateChange}
                        disabled={isHalfDay}
                      />
                      {formik.touched.to_date && formik.errors.to_date && (
                        <div className="text-danger mt-1">
                          {formik.errors.to_date}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Number of Leaves</label>
                    <input
                      type="text"
                      className="form-control"
                      value={leaveDays}
                      disabled
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label">
                      Reason <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      name="reason"
                      rows="3"
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.reason && formik.errors.reason && (
                      <div className="text-danger mt-1">
                        {formik.errors.reason}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <button type="submit" className="btn btn-primary mx-1">
                      Add Leave
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handelClear}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <>
                <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Sr. No.</th>
            <th>Leave Type</th>
            <th>From</th>
            <th>To</th>
            <th>No. of Leaves</th>
            <th>Reason</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {appliedLeaves?.applications?.map((app, index) => (
            <tr key={app.id}>
              <td>{index + 1}</td>
              <td>{app.leave_type}</td>
              <td>{app.from_date}</td>
              <td>{app.to_date}</td>
             <td>{parseFloat(app.number_of_leaves).toFixed(1)}</td>

              <td>{app.reason}</td>
              <td
                className={
                  app.status === "Approved"
                    ? "text-success fw-bold"
                    : app.status === "Rejected"
                    ? "text-danger fw-bold"
                    : "text-warning fw-bold"
                }
              >
                {app.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EssLeaves;
